module.exports = __webpack_public_path__ + "img/edit-avatar-icon.bd6d7803.svg";